import { createContext, type MouseEvent } from 'react'

export type DocsNavigate = (
  event: MouseEvent<HTMLAnchorElement>,
  href: string
) => void

export const DocsNavigateContext = createContext<DocsNavigate>(() => {})
